export const get_fields = {
  methods: {
    get_lang_pair: function() {
      this.$http.get(this.$store.getters.api_endpoint + "/lang_pair")
        .then( response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            var lang_pairs = {
              all: {}
            };
            for(var lang_pair of response.data){
              if(lang_pair.source_lang in lang_pairs.all){
                lang_pairs.all[lang_pair.source_lang].push(
                  lang_pair.target_lang
                );
              }else{
                lang_pairs.all[lang_pair.source_lang] = [
                  lang_pair.target_lang
                ];
              }
            }
            this.$store.commit("setLangPairs", lang_pairs);
            this.get_fields();
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    get_fields: function(){
      this.$http.get(this.$store.getters.api_endpoint + "/field")
        .then( response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }

            var data = {
              types: [
                "translatable",
                "trainable"
              ],
              langs: [
                "en",
                "ja"
              ]
            };

            // データ初期化
            var result = {};
            var lang_pairs = Object.assign({}, this.$store.getters.lang_pairs);
            for(var type of data.types){
              result[type] = {};
              lang_pairs[type] = {};
              for(var lang of data.langs){
                result[type][lang] = {};
                for(var source_lang in this.$store.getters.lang_pairs.all){
                  for(var target_lang of this.$store.getters.lang_pairs.all[source_lang]){
                    var current_lang_pair = source_lang + "_" + target_lang;
                    result[type][lang][current_lang_pair] = {
                      "root": {
                        children: []
                      }
                    };
                  }
                }
              }
            }

            for(var field of response.data){
              var lang_pair = field.source_lang + "_" + field.target_lang;
              var name = "";
              for(var type of data.types){
                for(var lang of data.langs){
                  if(!field.name[lang]){
                    name = field.name["en"];
                  }else{
                    name = field.name[lang];
                  }
                  var field_lang_pair = result[type][lang][lang_pair];
                  if(!field_lang_pair[field.parent_lid]){
                    field_lang_pair[field.parent_lid] = {
                      children: [
                        field.lid
                      ]
                    }
                  }else{
                    field_lang_pair[field.parent_lid]["children"].push(field.lid);
                  }
                  if(!field_lang_pair[field.lid]){
                    field_lang_pair[field.lid] = {
                      name: name,
                      children: [],
                      available: field[type] ? field[type] : false
                    }
                  }else{
                    field_lang_pair[field.lid].name = name;
                    field_lang_pair[field.lid].available = field[type] ? field[type] : false;
                  }
                  if(!field_lang_pair[field.lid].available){
                    var message_lang = lang;
                    if(!this.$i18n.messages[message_lang]){
                      message_lang = "en";
                    }
                    field_lang_pair[field.lid].name
                      += " (" + this.$i18n.messages[message_lang].message.common.not_selctable + ")"
                  }
                }
                if(field[type]){
                  if(!(field.source_lang in lang_pairs[type])){
                    lang_pairs[type][field.source_lang] = [
                      field.target_lang
                    ];
                  }else if(lang_pairs[type][field.source_lang].indexOf(field.target_lang) === -1){
                    lang_pairs[type][field.source_lang].push(
                      field.target_lang
                    );
                  }
                }
              }
            }
            if(this.$store.getters.debug){
              console.log(result);
              console.log(lang_pairs);
            }
            this.$store.commit("setFields", result);
            this.$store.commit("setLangPairs", lang_pairs);
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    }
  }
}
